import { pick } from 'ramda';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withProps, withHandlers } from 'recompose';

import withLoading from '../../../../common/withLoading';
import { getUserUrlPrefix } from '../../../../auth/selectors';
import poVendorsProvider from '../hoc/poVendorsProvider';
import { canUserModifyProducts } from '../../../../common/helpers/users';

const mapApiItemToListItem = pick(['name', 'email', 'enabled', 'id']);

const VendorListContainer = compose(
  connect(state => ({
    baseUrl: `${getUserUrlPrefix(state)}/products/purchase-orders/vendors`,
    canEditProducts: canUserModifyProducts(state.auth.permissions),
  })),
  withRouter,
  withHandlers({
    goToEditing: props => (vendorId) => {
      props.router.push(`${props.baseUrl}/${vendorId}/edit`);
    },
  }),
  poVendorsProvider(),
  withProps(props => ({
    listItems: props.vendors.map(mapApiItemToListItem),
    showLoading: props.isLoadingVendors,
  })),
  withLoading,
);

export default VendorListContainer;
